import { render, staticRenderFns } from "./role_type.vue?vue&type=template&id=400d55ed"
import script from "./role_type.vue?vue&type=script&lang=js"
export * from "./role_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports